exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".repo-information h1 {\n  text-transform: capitalize; }\n\n.repo-information .repo-description {\n  margin-bottom: 10px; }\n\n.repo-information .repo-image {\n  width: 100px;\n  margin: auto; }\n\n.repo-information .toggle-btn.active {\n  color: #000;\n  background: transparent; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/github-repo/github-repo.component.scss
// module id = ./src/app/components/github-repo/github-repo.component.scss
// module chunks = main